import { JSONSchema7 } from 'json-schema';
import { PagePermissionLevel } from '../Enums/pagePermissionLevel';
import JSONSchema7Properties from '../jSONSchema7Properties';

export default (pageSchema: JSONSchema7, role: string): PagePermissionLevel => {
  const pageProperties = pageSchema.properties as JSONSchema7Properties;
  let pagePermission: PagePermissionLevel | undefined;
  Object.getOwnPropertyNames(pageProperties).forEach((propName: string) => {
    if (pageProperties[propName].title === role) {
      pagePermission = pageProperties[propName].default as PagePermissionLevel;
      return;
    }
  });

  return pagePermission || PagePermissionLevel.NoAccess;
};
